import { IFilter } from '@epicuro-next/ataraxia/models';
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

import { defaultAllValue } from '../../constants';
import { isRegularFilter } from '../is-regular-filter/is-regular-filter';

export const addDefaultActiveFilters = (
  availableFilters: OrderFilter[],
  selectedFilters: IFilter[],
): IFilter[] => {
  const defaultActiveFilters = availableFilters
    .filter((filter) => !filter.isMultiple && isRegularFilter(filter))
    .filter((filter) =>
      selectedFilters.every(
        (activeFilter) => activeFilter.fieldId !== filter.fieldId,
      ),
    )
    .map((filter) => ({
      fieldId: filter.fieldId,
      value: defaultAllValue,
    }));

  return [...selectedFilters, ...defaultActiveFilters];
};

export const isDefaultFilterValue = (filter: IFilter) =>
  filter.value === defaultAllValue;
